import React from 'react';
import { connect } from "react-redux";
import { RegionSwitch } from "signoxe/components/widgets/index";
import { updateProfile } from "signoxe/actions";

const MULTIREGION_SWITCH_KEY = "multiregion_switch";

class Widget extends React.PureComponent {

  render() {
    return <RegionSwitch label={this.props.label}
      formId={MULTIREGION_SWITCH_KEY}
      checked={this.props.switchedOn}
      onChange={(e) => this.props.setMultiregion(e.currentTarget.checked)}
      size="tiny"
    />
  }

}

const mapStateToProps = state => {
  return {
    switchedOn: localStorage.getItem(MULTIREGION_SWITCH_KEY) == "true"
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMultiregion: value => dispatch(updateProfile(ownProps.profile.username, {
      multiregion_switch: value,
    }))
  }
};

export const MultiregionToggleWidget = connect(mapStateToProps, mapDispatchToProps)(Widget);




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/MultiregionToggleWidget/index.js